/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions,
    Table,
} from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const FFIEC031ResultsAccordian = (
    {
        columns, criteria, fetchData, data, pages, pagesize,
        setPageSize, setPageNumber, pageSizeOptions,
    },
) => (
    <div>
        <Accordions className="true-comply-ffiec031-accordion" activeItem={['panel-1', 'panel-2']}>
            <AccordionItem itemId="panel-1" size="lg">
                <AccordionItemHeader className="background-white header" title="DIAGNOSTIC CRITERIA" />
                <AccordionItemBody className="background-white" size="lg">
                    <hr style={{ marginTop: 0 }} />
                    <Row>
                        <Col md={6}>
                            <Row>
                                <Col md={3} className="a-h6">
                                    Category
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria && criteria.editType}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    MDRM List
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.mdrmList}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Description
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.ruleDescription}
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Effective End Date
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.effectiveEndDate}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Edit Number
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.editNumber}
                                </Col>
                            </Row>
                            <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                <Col md={3} className="a-h6">
                                    Schedule / Part
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {`${criteria?.schedule} / ${criteria?.targetItem}`}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem itemId="panel-2" style={{ marginTop: '1rem' }}>
                <AccordionItemHeader className="background-white header" title="RESULTS" />
                <AccordionItemBody className="background-white">
                    <hr style={{ marginTop: 0 }} />
                    <Table
                        columns={columns}
                        manual
                        data={data}
                        pages={pages}
                        onFetchData={fetchData}
                        defaultPageSize={pagesize}
                        onPageSizeChange={pageSize => setPageSize(pageSize)}
                        onPageChange={pageIndex => setPageNumber(pageIndex + 1)}
                        pageSizeOptions={pageSizeOptions}
                        noDataText="No Failed Data ..!!!"
                    />
                </AccordionItemBody>
            </AccordionItem>
        </Accordions>
    </div>
);

export default FFIEC031ResultsAccordian;
